import type { SeriesLineOptions } from "highcharts";

export const isAllZeroSeries = (lineGraphData: Array<Pick<SeriesLineOptions, "data">>): boolean => {
    return lineGraphData.every(
        (series) =>
            Array.isArray(series.data) &&
            series.data.every((point) => typeof point === "object" && point !== null && "y" in point && point.y === 0),
    );
};
